interface Scripts {
  name: string;
  src: string;
}
export const ScriptStore: Scripts[] = [
  // { name: 'clientLibsBase', src: '../../ecommerce/assets/js/clientlibs-base.js' },
  { name: 'clientLibsAll', src: '../../assets/js/clientlibs-all.js' }
];